import { HOMEPAGE_WIDTH_LARGE, HOMEPAGE_WIDTH_MEDIUM } from 'src/rebrand/Homepage/components/shared/MaxHomepageWidth';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const PADDING = 16;
export const SHADOW_BREATHING_ROOM = 36;
export const IS_ONSCREEN_THRESHOLD = 500; // (Only applies on large screens)

export const PanelCarouselContainerRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const PanelCarouselRow = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  overflow-x: scroll;
  overflow-y: clip;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  scroll-padding-left: ${SHADOW_BREATHING_ROOM}px;
  & > * {
    scroll-snap-align: start;
  }
  @media (max-width: ${ScreenWidth.MEDIUM}) {
    scroll-padding-left: ${PADDING}px;
  }

  ${minScreen(ScreenWidth.MEDIUM)} {
    scroll-padding-left: calc((100% - ${HOMEPAGE_WIDTH_MEDIUM}px) / 2);
  }
  ${minScreen(ScreenWidth.LARGE)} {
    scroll-padding-left: calc((100% - ${HOMEPAGE_WIDTH_LARGE}px) / 2);
  }

  // Give box shadows breathing room at the bottom of this scrollable div
  padding-bottom: 50px;
  margin-bottom: -50px; // Prevent this from affecting anything outside the component

  & > * {
    opacity: 1;
    transition: opacity 0.11s ease-in-out;

    margin-right: ${Spacing.SINGLE};
    ${minScreen(ScreenWidth.SMALL)} {
      margin-right: ${Spacing.SINGLE_HALF};
    }

    box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.1);
  }

  & > :first-child {
    margin-left: ${PADDING}px;

    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-left: calc((100% - ${HOMEPAGE_WIDTH_MEDIUM}px) / 2);
    }
    ${minScreen(ScreenWidth.LARGE)} {
      margin-left: calc((100% - ${HOMEPAGE_WIDTH_LARGE}px) / 2);
    }
  }
  & > :nth-last-child(-n + 3) {
    margin-right: ${PADDING}px;

    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-right: calc((100% - ${HOMEPAGE_WIDTH_MEDIUM}px) / 2);
    }
    ${minScreen(ScreenWidth.LARGE)} {
      margin-right: calc((100% - ${HOMEPAGE_WIDTH_LARGE}px) / 2);
    }
  }
`;

export const PanelCarouselCircleTabs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 10px;
  cursor: pointer;
  // z-index to address cases where the carousel has a margin/padding that covers the circles
  z-index: 1;
`;
